// @ts-ignore
import AuthenticationContext from 'adal-angular/lib/adal.js';
const resourceId = process.env.VUE_APP_AZURE_CLIENT_ID;
const config = {
    tenant: 'geshdo.onmicrosoft.com',
    clientId: resourceId,
    redirectUri: process.env.VUE_APP_REDIRECT_URL,
    cacheLocation: 'localStorage',
    resource: 'https://management.core.windows.net/',
};
export default {
    authenticationContext: null,
    /**
     * @return {Promise}
     */
    initialize() {
        this.authenticationContext = new AuthenticationContext(config);
        return new Promise((resolve, _reject) => {
            if (this.authenticationContext.isCallback(window.location.hash) || window.self !== window.top) {
                // redirect to the location specified in the url params.
                this.authenticationContext.handleWindowCallback();
                console.log("LOGIN: authenticaiton callback has occured");
            }
            else {
                // try pull the user out of local storage
                const user = this.authenticationContext.getCachedUser();
                console.log("LOGIN: tryting to retrieve cached user");
                if (user) {
                    //console.log(user.profile);
                    resolve();
                    console.log("LOGIN: a cahced user has been retrieved");
                }
                else {
                    // no user at all - go sign in.
                    console.log("LOGIN: trying to login isntead");
                    this.signIn();
                }
            }
        });
    },
    /**
     * @return {Promise.<String>} A promise that resolves to an ADAL token for resource access
     */
    acquireToken() {
        return new Promise((resolve, reject) => {
            this.authenticationContext.acquireToken(resourceId, (error, token) => {
                if (error || !token) {
                    const errCode = error.split(':')[0];
                    console.log("Error - " + errCode);
                    console.log("Error - TOKEN " + token);
                    switch (errCode) {
                        case 'AADSTS50058': // Need to prompt for user sign in
                            AuthenticationContext.login();
                            break;
                        case 'AADSTS65001': // Token is invalid; grab a new one
                            console.log("LOGIN: The token is invalid trying to get a new one");
                            AuthenticationContext.acquireTokenRedirect(resourceId);
                            break;
                        case 'AADSTS16000': // No Access
                            console.log("no Access");
                            break;
                        default:
                            // Need a pop-up forcing a login
                            AuthenticationContext.login();
                            break;
                    }
                    return;
                }
                else {
                    //console.log("BEARER " + token)
                    return resolve(token);
                }
            });
        });
    },
    /**
     * Issue an interactive authentication request for the current user and the api resource.
     */
    acquireTokenRedirect() {
        this.authenticationContext.acquireTokenRedirect(resourceId);
    },
    /**
     * @return {Boolean} Indicates if there is a valid, non-expired access token present in localStorage.
     */
    isAuthenticated() {
        // getCachedToken will only return a valid, non-expired token.
        if (this.authenticationContext.getCachedToken(config.clientId)) {
            return true;
        }
        return false;
    },
    /**
     * @return An ADAL user profile object.
     */
    getUserProfile() {
        return this.authenticationContext.getCachedUser().profile;
    },
    signIn() {
        this.authenticationContext.login();
    },
    signOut() {
        this.authenticationContext.logOut();
    },
};
//the authentication is used in 3 places in the code, the main file for init
// the store file for retrieving a new cookie
// the router file to check if the user is allowed to see a route or not.
